export default __webpack_public_path__ + "static/media/sc32.7a42cc26.jpg";